module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/mainpage/cover/cover.component.css
// module id = ./src/mainpage/cover/cover.component.css
// module chunks = main